<template>
  <Card>
    <template slot="header">Profile</template>
    <v-layout column>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-text-field
          v-model="editedPerson.firstName"
          :disabled="!editable"
          :rules="[validationRules.required]"
          label="First Name"
          prepend-icon="fa-user"
        />
        <v-text-field
          v-model="editedPerson.lastName"
          :rules="[validationRules.required]"
          :disabled="!editable"
          label="Last Name"
          prepend-icon="fa-user"
        />
        <v-text-field
          v-model="editedPerson.email"
          :rules="[validationRules.required, validationRules.email]"
          :disabled="!editable"
          label="Email"
          browser-autocomplete="username"
          prepend-icon="fa-envelope"
        />
        <v-text-field
          v-model="editedPerson.address1"
          :rules="[validationRules.required]"
          :disabled="!editable"
          label="Address 1"
          prepend-icon="fa-map-marker"
        />
        <v-text-field
          v-model="editedPerson.address2"
          :disabled="!editable"
          label="Address 2"
          prepend-icon="fa-map-marker-alt"
        />
        <v-text-field
          v-model="editedPerson.city"
          :rules="[validationRules.required]"
          :disabled="!editable"
          label="City"
          prepend-icon="fa-building"
        />
        <v-text-field
          v-model="editedPerson.state"
          :rules="[validationRules.required]"
          :disabled="!editable"
          label="State"
          prepend-icon="fa-monument"
        />
        <v-text-field
          v-model="editedPerson.country"
          :rules="[validationRules.required]"
          :disabled="!editable"
          label="Country"
          prepend-icon="fa-globe-americas"
        />
        <v-text-field
          v-model="editedPerson.zip"
          :disabled="!editable"
          label="Zip Code"
          prepend-icon="fa-hashtag"
        />
        <v-menu
          :nudge-right="30"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <v-text-field
            v-if="false"
            slot="activator"
            v-model="editedPerson.dateOfBirth"
            :rules="[validationRules.required]"
            :disabled="!editable"
            label="Date Of Birth"
            prepend-icon="event"
            readonly
          />
          <v-date-picker
            ref="picker"
            v-model="editedPerson.dateOfBirth"
            :max="new Date().toISOString().substr(0, 10)"
            min="1900-01-01"
          />
        </v-menu>
        <v-text-field
          v-model="editedPerson.phone1"
          :disabled="!editable"
          label="Primary Phone"
          prepend-icon="fa-phone-square"
        />
        <v-text-field
          v-model="editedPerson.phone2"
          :disabled="!editable"
          label="Secondary Phone"
          prepend-icon="fa-mobile-alt"
        />
        <v-text-field
          v-model="editedPerson.emergencyContactName"
          :disabled="!editable"
          label="Emergency Contact Name"
          prepend-icon="fa-notes-medical"
        />
        <v-text-field
          v-model="editedPerson.emergencyContactPhone"
          :disabled="!editable"
          label="Emergency Contact Phone"
          prepend-icon="fa-phone-square"
        />
        <v-text-field
          v-model="editedPerson.emergencyContactPhone"
          :disabled="!editable"
          label="Emergency Contact Phone"
          prepend-icon="fa-phone-square"
        />
        <v-btn
          v-if="editable"
          @click="submit()">
          Submit
        </v-btn>
      </v-form>
    </v-layout>
  </Card>
</template>

<script>
// import vuex mapping
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      valid: false,
      editedPerson: {}
    }
  },
  computed: {
    ...mapGetters({
      proxyPerson: 'person/proxyPerson'
    }),
    editable () {
      return !this.proxyPerson || this.assertSetting('personEdit', 1)
    }
  },
  mounted () {
    this.editedPerson = Object.assign({}, this.person) // get the person
    this.$refs.picker.activePicker = 'YEAR'
  },
  methods: {
    ...mapActions({
      updatePerson: 'person/updatePerson'
    }),
    submit () {
      if (this.$refs.form.validate()) {
        this.updatePerson(Object.assign({}, this.editedPerson))
      }
    }
  }
}
</script>
